/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { initAxios } from '../utils/axiosHelper';
import { parseErrorMsg } from '../utils/errorHelper';
import { FilePaginationParams } from './bitedb/files/file';

export const FileAPI = {
  getUploadsByGroupId: async (
    groupId: string,
    params?: Partial<FilePaginationParams>,
  ) => {
    const queryParams = new URLSearchParams({
      page: (params?.page || 1).toString(),
      limit: (params?.limit || 10).toString(),
      sortBy: params?.sortBy || 'created_at',
      sortOrder: params?.sortOrder || 'desc',
      search: params?.search || '',
      type: params?.type || '',
      databaseProductIds: params?.databaseProductIds || '',
    });
    try {
      const response = await (
        await initAxios()
      )?.get(`/bite-db/uploads/group/${groupId}?${queryParams.toString()}`);

      return {
        success: response?.status === 200,
        result: response?.data,
      };
    } catch (e) {
      console.error(`Error while fetching uploads by group id: ${e}`);
      return {
        success: false,
        result: parseErrorMsg(e),
      };
    }
  },

  getUploadsByDatabaseId: async (
    databaseId: string,
    params?: Partial<FilePaginationParams>,
  ) => {
    const queryParams = new URLSearchParams({
      page: (params?.page || 1).toString(),
      limit: (params?.limit || 10).toString(),
      sortBy: params?.sortBy || 'created_at',
      sortOrder: params?.sortOrder || 'desc',
      search: params?.search || '',
      type: params?.type || '',
    });
    try {
      const response = await (
        await initAxios()
      )?.get(
        `/bite-db/uploads/database/${databaseId}?${queryParams.toString()}`,
      );

      return {
        success: response?.status === 200,
        result: response?.data,
      };
    } catch (e) {
      console.error(`Error while fetching uploads by database id: ${e}`);
      return {
        success: false,
        result: parseErrorMsg(e),
      };
    }
  },

  getUploadsByDatabaseProductId: async (
    databaseProductId: string,
    params?: Partial<FilePaginationParams>,
  ) => {
    const queryParams = new URLSearchParams({
      page: (params?.page || 1).toString(),
      limit: (params?.limit || 10).toString(),
      sortBy: params?.sortBy || 'created_at',
      sortOrder: params?.sortOrder || 'desc',
      search: params?.search || '',
      type: params?.type || '',
    });
    try {
      const response = await (
        await initAxios()
      )?.get(
        `/bite-db/uploads/database-product/${databaseProductId}?${queryParams.toString()}`,
      );

      return {
        success: response?.status === 200,
        result: response?.data,
      };
    } catch (e) {
      console.error(
        `Error while fetching uploads by database product id: ${e}`,
      );
      return {
        success: false,
        result: parseErrorMsg(e),
      };
    }
  },

  downloadUploadById: async (uploadId: string) => {
    try {
      const response = await (await initAxios())?.get(`/bite-db/uploads/${uploadId}/download`, {
        responseType: 'blob',
      });

      return {
        success: response?.status === 200,
        result: response?.data,
      };
    } catch (e) {
      console.error(`Error while downloading upload by id: ${e}`);
      return {
        success: false,
        result: parseErrorMsg(e),
      };
    }
  },

  uploadFile: async (
    file: File,
    databaseId?: string,
    databaseProductId?: string,
  ) => {
    const formData = new FormData();
    formData.append('file', file);
    if (databaseId) {
      formData.append('database_id', databaseId);
    }
    if (databaseProductId) {
      formData.append('database_product_id', databaseProductId);
    }

    return (await initAxios())
      ?.post('/bite-db/uploads', formData, {
        // CRITICAL: This prevents Axios from stringifying the FormData
        transformRequest: [(data) => data],
      })
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      });
  },
};

export default FileAPI;
